// useVehicleRecognition — subscribes to the weighbridge SSE live feed and
// surfaces vehicle_recognized events from the agent barcode scanner.
//
// Opens its own SSE connection (independent of the weight-feed hook) so the
// popup can be mounted on any page that has a weighbridge context without
// requiring the caller to also consume live weight readings.

import { useState } from 'react';

import { useWbLiveFeed, type WbVehicleRecognizedEvent } from './wb/useWbLiveFeed';

export interface UseVehicleRecognitionResult {
  event: WbVehicleRecognizedEvent | null;
  dismiss: () => void;
}

export function useVehicleRecognition(
  enabled = true,
): UseVehicleRecognitionResult {
  const [event, setEvent] = useState<WbVehicleRecognizedEvent | null>(null);

  useWbLiveFeed({
    onVehicleRecognized: (e) => setEvent(e),
    enabled,
  });

  return {
    event,
    dismiss: () => setEvent(null),
  };
}
